module.exports = __webpack_public_path__ + "img/5.c104edb4.jpg";